import React, {Suspense} from 'react';
import PageLayout from "@view/layout/pageLayout/PageLayout";
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import {MonitoringSingleVoyagesLazy} from "@containers/singleVoyage/monitoringVoyages/MonitoringSingleVoyages.lazy";


const MonitoringSingleVoyagesPage = () => {
    return (
        <PageLayout
        >
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <MonitoringSingleVoyagesLazy/>
            </Suspense>
        </PageLayout>
    );
};

export default MonitoringSingleVoyagesPage;